module.exports = __webpack_public_path__ + "img/rating.cc678463.svg";